module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/18TA9dK/CoverDesign.jpg?1684514919070",
      "alt": "This image is the cover for the book Dopo il tramonto, Tempo al tempo"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Dopo il tramonto, Tempo al tempo\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_c('i', [_vm._v("Tempo al tempo, Libro 2")])])]), _c('p', [_vm._v("Sono passati due anni da quando Stefan Joss si è trasferito nel sud degli Stati Uniti per amore del rancher Rand Holloway. Stef ha cercato – con esitazione – di adeguarsi alla sua nuova vita, ma il vero amore non fila mai liscio come dovrebbe. Rand vuole che lui rimanga a casa al ranch, Stef vuole avere una rete di sicurezza nel caso Rand decida di sbarazzarsi di lui. Finalmente, dopo aver capito di essere stato ingiusto a dubitare di lui, Stef decide di impegnarsi sul serio con Rand e l’uomo è al settimo cielo.")]), _vm._v(" "), _c('p', [_vm._v("Quando Stef ha l’opportunità di provare il suo amore, non si tira indietro, mettendo a repentaglio la sua stessa vita. E Rand ha la possibilità di dimostrare che – a volte – la vita può sorprenderti quando meno te lo aspetti.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Mary Calmes, N.A.M.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Dreamspinner Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0